export default __webpack_public_path__ + "static/media/soleil_book.12c0dc05.woff";